<template>
  <div id="about_nav">
    <div class="nav-top">
      <div class="top-box">
        <h3>加入我们</h3>
        <p>Join us</p>
      </div>
    </div>
    <div class="nav-box">
      <div class="nav-bottom">
        <div class="seat-box">
          <h3>
            您的位置：首页 > 加入我们 >
            <span>成为志愿者</span>
          </h3>
          <div :class="{'border-box':classShow, 'animated': classHide, 'fadeInUpBig': classHide}"></div>
        </div>
        <ul>
          <li
            v-for="(item,index) in navList"
            :key="index"
            @click="getStyle(item.id)"
            :class="{active:liStatus==item.id}"
          >{{item.title}}</li>
        </ul>
      </div>
    </div>
    <div class="nav-content">
      <div class="volunteer-box">
        <h3>如何成为志愿者</h3>
        <p>""天使之旅"是中国红十字基金会于2012年发起的志愿者活动，引入社会调查和志愿服务机制，通过招募志愿者开展入户调查，倡导"公益旅行"，以"微记录"的方式发现和记录民生诉求，动员社会开展点对点的救助，为最易受损人群创造更好的人道救助渠道。</p>
        <p>爱佑儿童医疗项目矩阵倾力于孤贫儿童的医疗救助，开展的项目包括“爱佑童心”——孤贫先天性心脏病患儿手术治疗项目、“爱佑天使”——孤贫血液病及肿瘤患儿医疗救助项目、“爱佑和康”——残障儿童康复项目和“爱佑晨星”——孤贫儿童多病种医疗救助项目。截至 2017 年 12 月底，爱佑儿童医疗项目矩阵累计救助孤贫患儿超过 50,000 人。其中，“爱佑童心”是全球规模最大的孤贫先心病患儿救助项目。爱佑儿童医疗项目矩阵支持医疗机构开展十余项临床科研，并已成功将部分成果应用于临床。2017 年，爱佑升级了科研合作模式，与 4 家全国顶尖儿童执行机构开展了整体科研合作，与此同时，与中国医学科学院肿瘤执行机构开展一项专项科研合作。爱佑还建立了心血管医护人员培训体系和评估体系，帮助各受训单位提高儿童心血管疾病治疗水平。2016 年，爱佑建立了首个“中国先天性心脏病外科手术数据库”，截至2018年6月底已录入超过 30,000 例先心病手术数据。</p>
        <p>爱佑儿童福利项目矩阵包括“爱佑新生”—— 病患孤儿养护项目和“爱佑安生”——困境儿童救助与保护项目。“爱佑新生”作为全球规模最大的病患孤儿养护项目，截至 2018 年 6 月底，已累计帮助超过10,000 名病患孤儿获得新生；“爱佑安生” 牵头搭建由政府部门、社会组织、捐赠人等多方组成的儿童福利服务和儿童权益保护平台，在云南、贵州、青海等 6 省 12县 190 个村开展试点工作，覆盖儿童超过 50,000</p>
      </div>
      <div class="btn-box">
        <router-link to="/volunteerApply">
          <button>明白了，立即成为志愿者</button>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      classShow: true,
      classHide: false,
      navShow: 1,
      navList: [
        {
          id: 1,
          title: "成为志愿者"
        },
        {
          id: 2,
          title: "人才招聘"
        }
      ],
      liStatus: 1
    };
  },
  methods: {
    getStyle(id) {
      this.liStatus = id;
      this.navShow = id;
    }
  }
};
</script>
<style lang="scss" scoped>
#about_nav {
  width: 100%;
}
.nav-top {
  width: 100%;
  height: 300px;
  background: url(../../assets/images/nav_bg.png) no-repeat;
  background-size: 100% 100%;
  .top-box {
    width: 1300px;
    margin: 0 auto;
    padding-top: 118px;
    > h3 {
      font-size: 36px;
      color: #333333;
      font-weight: normal;
    }
    > p {
      font-size: 26px;
      font-weight: normal;
      color: #999999;
    }
  }
}
.nav-box {
  width: 1300px;
  margin: 0 auto;
  // margin-bottom: 86px;
  .nav-bottom {
    width: 100%;
    .seat-box {
      > h3 {
        font-size: 14px;
        color: #999;
        text-align: right;
        font-weight: normal;
        padding: 28px 0 17px;
        > span {
          color: #333333;
        }
      }
      .border-box {
        width: 1300px;
        height: 1px;
        border: 1px solid #c30d23;
        border-bottom: 3px solid #c30d23;
      }
    }
    > ul {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      > li {
        list-style: none;
        padding: 15px 25px;
        font-size: 18px;
        color: #000000;
        cursor: pointer;
        &.active {
          // background-color: #fff;
          background-color: #c30d23;
          color: #fff;
        }
      }
    }
  }
}
.nav-content {
  width: 1300px;
  margin: 0 auto;
  .volunteer-box {
    padding-top: 56px;
    > h3 {
      font-size: 30px;
      color: #333333;
      margin-bottom: 30px;
    }
    > p {
      font-size: 16px;
      color: #666666;
      line-height: 30px;
      margin-bottom: 30px;
    }
  }
  .btn-box {
    margin-top: 75px;
    text-align: center;
    margin-bottom: 270px;
    > a {
      > button {
        margin: 0;
        padding: 0;
        border: none;
        outline: none;
        font-size: 21px;
        color: #ffffff;
        width: 261px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        background-color: #c30d23;
        box-shadow: 2px 3px 10px 0px rgba(9, 1, 4, 0.21);
        border-radius: 6px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Join/join_nav.vue